import React, { memo } from "react";
import { Link } from "react-router-dom";

const BranchTable = memo(({ branches, onDelete }) => {
  return (
    <div className="tw-overflow-x-auto">
      <table className="tw-min-w-full tw-divide-y tw-divide-gray-200">
        <thead className="tw-bg-gray-50">
          <tr>
            <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Name</th>
            <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Agent</th>
            <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Location</th>
            <th className="tw-px-6 tw-py-3 tw-text-center tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="tw-bg-white tw-divide-y tw-divide-gray-200">
          {branches.map(branch => (
            <tr key={branch._id} className="hover:tw-bg-gray-50">
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-gray-900">{branch.name}</td>
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">{branch.agent}</td>
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">{branch.location}</td>
              <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-500 tw-text-center tw-space-x-4">
                <button
                  onClick={() => onDelete(branch._id)}
                  className="tw-text-red-600 hover:tw-text-red-800"
                >
                  Delete
                </button>
                <Link
                  to={`/updatebranch/${branch._id}`}
                  className="tw-text-indigo-600 hover:tw-text-indigo-800"
                >
                  Edit
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default BranchTable;